import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { DateInput } from '@uhg-abyss/web/ui/DateInput';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import React from 'react';

import { FormSkeleton } from './components/Skeleton';
import fields from './includes/fields.json';

const { reportDate: fieldReportDate } = fields;

/**
 * Form
 *
 * @param isLoading
 * @param reportDate
 * @param setReportDate
 * @returns {Element}
 * @constructor
 */
export function Form({ isLoading, reportDate, setReportDate }) {
  return (
    <ErrorHandler location="src/pages/private/Dashboards/RiskDashboard/components/Form/Form.jsx">
      <Grid css={{ margin: 0 }}>
        <Grid.Col
          css={{ paddingLeft: 0 }}
          span={{
            xs: '100%',
          }}
        >
          {isLoading ? (
            <FormSkeleton />
          ) : (
            <DateInput {...fieldReportDate} onChange={setReportDate} value={reportDate} />
          )}
        </Grid.Col>
      </Grid>
    </ErrorHandler>
  );
}
